export default __webpack_public_path__ + "static/media/hyundai.4604caac.svg";